module.exports = __webpack_public_path__ + "static/media/support_teal.457279c0.png";